import React from "react";
import WidgetsOutlined from "@mui/icons-material/WidgetsOutlined";
import GroupAddOutlined from "@mui/icons-material/GroupAddOutlined";
import MenuBookOutlined from "@mui/icons-material/MenuBookOutlined";
import CalendarViewMonthOutlined from "@mui/icons-material/CalendarViewMonthOutlined";
import AccountBalanceWalletOutlined from "@mui/icons-material/AccountBalanceWalletOutlined";
import CampaignOutlined from "@mui/icons-material/CampaignOutlined";
import EmojiEventsOutlined from "@mui/icons-material/EmojiEventsOutlined";
import ForumOutlined from "@mui/icons-material/ForumOutlined";
import ShieldOutlined from "@mui/icons-material/ShieldOutlined";
import TableChartOutlined from "@mui/icons-material/TableChartOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import HomeOutlined from "@mui/icons-material/HomeOutlined";
import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import PeopleOutlined from "@mui/icons-material/PeopleOutlined";
import PaymentOutlined from "@mui/icons-material/PaymentOutlined";
import EventOutlined from "@mui/icons-material/EventOutlined";
import MailOutlined from "@mui/icons-material/MailOutlined";
import ChatOutlined from "@mui/icons-material/ChatOutlined";
import DashboardOutlined from "@mui/icons-material/DashboardOutlined";
import BarChartOutlined from "@mui/icons-material/BarChartOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";
import WorkOutlineOutlined from "@mui/icons-material/WorkOutlineOutlined";
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";
import TrendingUpOutlined from "@mui/icons-material/TrendingUpOutlined";
import PhoneOutlined from "@mui/icons-material/PhoneOutlined";
import TaskOutlined from "@mui/icons-material/TaskOutlined";
import VpnKeyOutlined from "@mui/icons-material/VpnKeyOutlined";
import RedeemOutlined from "@mui/icons-material/RedeemOutlined";
import FlagOutlined from "@mui/icons-material/FlagOutlined";
import TrackChangesOutlined from "@mui/icons-material/TrackChangesOutlined";
import CalculateOutlined from "@mui/icons-material/CalculateOutlined";
import PaidOutlined from "@mui/icons-material/PaidOutlined";
import WorkspacePremiumOutlined from "@mui/icons-material/WorkspacePremiumOutlined";

/** Whitelist of MUI icon names allowed from API (App Builder). */
const ICON_MAP = {
  WidgetsOutlined,
  GroupAddOutlined,
  MenuBookOutlined,
  CalendarViewMonthOutlined,
  AccountBalanceWalletOutlined,
  CampaignOutlined,
  EmojiEventsOutlined,
  ForumOutlined,
  ShieldOutlined,
  TableChartOutlined,
  DescriptionOutlined,
  HomeOutlined,
  AssessmentOutlined,
  SettingsOutlined,
  PeopleOutlined,
  PaymentOutlined,
  EventOutlined,
  MailOutlined,
  ChatOutlined,
  DashboardOutlined,
  BarChartOutlined,
  SchoolOutlined,
  WorkOutlineOutlined,
  LocalOfferOutlined,
  TrendingUpOutlined,
  PhoneOutlined,
  TaskOutlined,
  VpnKeyOutlined,
  RedeemOutlined,
  FlagOutlined,
  TrackChangesOutlined,
  CalculateOutlined,
  PaidOutlined,
  WorkspacePremiumOutlined,
};

export function getNavIconComponent(name) {
  const Icon = ICON_MAP[name] || ICON_MAP.WidgetsOutlined;
  return Icon;
}

/** Renders <Icon /> for sidebar rows (same pattern as static appMenus). */
export function renderNavIcon(name) {
  const Icon = getNavIconComponent(name);
  return <Icon />;
}

export const NAV_ICON_OPTIONS = Object.keys(ICON_MAP).sort();
